import { render } from "./client-order-limit.vue?vue&type=template&id=1489a892&scoped=true"
import script from "./client-order-limit.vue?vue&type=script&lang=js"
export * from "./client-order-limit.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./client-order-limit.vue?vue&type=style&index=1&id=1489a892&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1489a892"]])

export default __exports__